/**
 * Hook for fetching aggregate audit statistics.
 * Auto-refreshes every 30 seconds.
 *
 * Three-mode branching:
 *   - "demo" → mock data (API unreachable or user toggled)
 *   - "public" / "live" → real API (GET /audit/stats is now public)
 *
 * The audit stats endpoint uses OptionalUser — no auth required.
 * Anonymous visitors see real aggregate counts proving the audit
 * pipeline is active.
 */

import { useQuery } from "@tanstack/react-query";
import { useDataMode } from "../providers/DataModeProvider";
import { getAuditStats } from "../services/audit";
import { generateAuditStats } from "../demo/generators";

export function useAuditStats() {
  const { mode } = useDataMode();

  return useQuery({
    queryKey: ["audit", "stats", mode],
    queryFn: () =>
      mode === "demo" ? Promise.resolve(generateAuditStats()) : getAuditStats(),
    refetchInterval: 30_000,
  });
}
